<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2019-12-23',
        items: [

          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-387',
            rare        : 'RR',
            name        : 'レインボーファンタジータイムドリームワンピ',
            imgUrl      : '/images/items/AM-387.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PP_FTD',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 0, usual: 0 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            numReleased : { kira: 0, usual: 0 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-388',
            rare        : 'RR',
            name        : 'レインボーファンタジータイムドリームシューズ',
            imgUrl      : '/images/items/AM-388.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PP_FTD',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 0, usual: 0 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            numReleased : { kira: 0, usual: 1 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-389',
            rare        : 'RR',
            name        : 'レインボーファンタジータイムドリームヘアアクセ',
            imgUrl      : '/images/items/AM-389.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PP_FTD',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 0, usual: 0 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            numReleased : { kira: 0, usual: 0 },  // 本来はプロモチケ。キラチケは PAF03 の復刻チャンネルで排出される
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            rare        : 'RR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-350',
            rare        : 'PR',
            name        : 'シークレットアリスワンダーランドトップス',
            imgUrl      : '/images/items/AM-350.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-351',
            rare        : 'PR',
            name        : 'シークレットアリスワンダーランドスカート',
            imgUrl      : '/images/items/AM-351.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-352',
            rare        : 'PR',
            name        : 'シークレットアリスワンダーランドシューズ',
            imgUrl      : '/images/items/AM-352.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-353',
            rare        : 'PR',
            name        : 'シークレットアリスワンダーランドヘアアクセ',
            imgUrl      : '/images/items/AM-353.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-354',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムそふぃアナザーワンピ',
            imgUrl      : '/images/items/AM-354.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'PP_HT',
            type        : 'CO',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-355',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムそふぃアナザーシューズ',
            imgUrl      : '/images/items/AM-355.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PP_HT',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-356',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムそふぃアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-356.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PP_HT',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-357',
            rare        : 'SR',
            name        : 'マリオネットミューパープルサイリウムワンピ',
            imgUrl      : '/images/items/AM-357.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-358',
            rare        : 'SR',
            name        : 'マリオネットミューパープルサイリウムシューズ',
            imgUrl      : '/images/items/AM-358.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-359',
            rare        : 'SR',
            name        : 'マリオネットミューパープルサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-359.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PP_MM',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            rare        : 'SR',
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-360',
            rare        : 'SR',
            name        : 'サーカスリングマスターブラックトップス',
            imgUrl      : '/images/items/AM-360.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-361',
            rare        : 'SR',
            name        : 'サーカスリングマスターブラックスカート',
            imgUrl      : '/images/items/AM-361.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-362',
            rare        : 'SR',
            name        : 'サーカスリングマスターブラックシューズ',
            imgUrl      : '/images/items/AM-362.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-363',
            rare        : 'SR',
            name        : 'サーカスリングマスターブラックヘアアクセ',
            imgUrl      : '/images/items/AM-363.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-364',
            rare        : 'SR',
            name        : 'ラビットハートキューティートップス',
            imgUrl      : '/images/items/AM-364.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-365',
            rare        : 'SR',
            name        : 'ラビットハートキューティースカート',
            imgUrl      : '/images/items/AM-365.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-366',
            rare        : 'SR',
            name        : 'ラビットハートキューティーシューズ',
            imgUrl      : '/images/items/AM-366.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-367',
            rare        : 'SR',
            name        : 'ラビットハートキューティーヘアアクセ',
            imgUrl      : '/images/items/AM-367.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PP_FT',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-368',
            rare        : 'R',
            name        : 'ワイズガールグリーントップス',
            imgUrl      : '/images/items/AM-368.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-369',
            rare        : 'R',
            name        : 'ワイズガールグリーンスカート',
            imgUrl      : '/images/items/AM-369.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-370',
            rare        : 'R',
            name        : 'ワイズガールグリーンシューズ',
            imgUrl      : '/images/items/AM-370.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-371',
            rare        : 'R',
            name        : 'ワイズガールグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-371.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-372',
            rare        : 'R',
            name        : 'セブンスコーデクールドレスアナザースタイル',
            imgUrl      : '/images/items/AM-372.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'PP_PR',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-373',
            rare        : 'R',
            name        : 'セブンスコーデクールシューズアナザースタイル',
            imgUrl      : '/images/items/AM-373.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PP_PR',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-374',
            rare        : 'R',
            name        : 'セブンスコーデクールヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-374.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PP_PR',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            rare        : 'R',
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-375',
            rare        : 'R',
            name        : 'フレンチレースブルートップス',
            imgUrl      : '/images/items/AM-375.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-376',
            rare        : 'R',
            name        : 'フレンチレースブルースカート',
            imgUrl      : '/images/items/AM-376.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-377',
            rare        : 'R',
            name        : 'フレンチレースブルーシューズ',
            imgUrl      : '/images/items/AM-377.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-378',
            rare        : 'R',
            name        : 'フレンチレースブルーヘアアクセ',
            imgUrl      : '/images/items/AM-378.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-379',
            rare        : 'N',
            name        : 'プリパリポリストップス',
            imgUrl      : '/images/items/AM-379.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-380',
            rare        : 'N',
            name        : 'プリパリポリスパンツ',
            imgUrl      : '/images/items/AM-380.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-381',
            rare        : 'N',
            name        : 'プリパリポリスシューズ',
            imgUrl      : '/images/items/AM-381.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-382',
            rare        : 'N',
            name        : 'プリパリポリスヘアアクセ',
            imgUrl      : '/images/items/AM-382.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PP_FP',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-383',
            rare        : 'N',
            name        : 'ストライプスターパープルトップス',
            imgUrl      : '/images/items/AM-383.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-384',
            rare        : 'N',
            name        : 'ストライプスターパープルスカート',
            imgUrl      : '/images/items/AM-384.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-385',
            rare        : 'N',
            name        : 'ストライプスターパープルシューズ',
            imgUrl      : '/images/items/AM-385.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラキラパック ～ミラクル☆キラッツ編～',
            id          : 'AM-386',
            rare        : 'N',
            name        : 'ストライプスターパープルヘアアクセ',
            imgUrl      : '/images/items/AM-386.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
        ],
      }
    },

    computed: {
      itemsRR () {
        return _.where(this.items, {  rare: 'RR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="RR ◆◆◆◆" color="#ff5d91" :items="itemsRR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col3>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
